<template>
<w-settings-content-template>
  <el-tabs slot="content" type="card" v-model="activeTab" @tab-click="onChangeMenu">
    <el-tab-pane label="도메인" name="WDomainList" class="h100 w100">
      <w-domain-list ref="domainList"></w-domain-list>
    </el-tab-pane>
    <el-tab-pane label="TCP/UDP 포트" name="WServicePort" class="h100 w100">
      <w-service-port ref="servicePort"></w-service-port>
    </el-tab-pane>
  </el-tabs>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WDomainList from './DomainList';
import WServicePort from './ServicePort';

export default {
  name: 'WDomainServicePort',
  components: {
    WSettingsContentTemplate,
    WDomainList,
    WServicePort,
  },
  data() {
    return {
      activeTab: 'WDomainList',
    };
  },
  methods: {
    onChangeMenu(menu) {
      // this.activeMenu = menu.name;
      if (menu.name === 'WDomainList') {
        this.$refs.domainList.loadData();
      } else {
        this.$refs.servicePort.loadData();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/DomainServicePort/index.vue